import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor} from '@elastic/eui';
import { ComboDireccionesNegocioContainer as ComboDNs} from '../../../components/Combos/DireccionesNegocio/container';
// import {ComboResponsablesAreaContainer as ComboresponsablesArea} from '../../../components/Combos/ResponsablesArea/container';
import { SelectorFuncionSubFuncion } from './selectorFuncionSubfuncion';
import { createFunSub } from './functions';

export const Formulario = (props)=>{

  let {onSave, selected, onClose} = props
  let [area,setArea] = useState(selected ? selected.area : undefined)
  let [codArea,setCodArea] = useState(selected ? selected.codArea : undefined)
  let [dn,setDn] = useState(selected ? selected.idDN : undefined)
  //let [responsable, setResponsable] = useState(selected ? selected.responsable : undefined)
  let [funcionesSubFunciones, setFuncionesSubFunciones] = useState(selected ? createFunSub(selected.funcionesSubFunciones) : [])
  
  const getFuncionesSubFunciones = () => {
    return funcionesSubFunciones.map((fs) => {return {codArea:codArea,idFuncion: fs.idFuncion, funcion: fs.funcion, idSubFuncion: fs.idSubFuncion, subFuncion: fs.subFuncion}})
  }

  const getData = () =>{
    let data = {idArea: (selected ? selected.idDN + '-' + selected.codArea : null), idDN: (Array.isArray(dn) ? dn[0].value : dn),codArea: codArea, area: area}
    if(selected){
      selected.funcionesSubFunciones = [...getFuncionesSubFunciones()];
      return {...selected,...data}
    }else{
      return {...data,...{funcionesSubFunciones: getFuncionesSubFunciones()}}
    }
  }

  const onSaveData = () =>{
    
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const onAgregateFuncionSubfuncion = (data) =>{
    setFuncionesSubFunciones([...funcionesSubFunciones,...data]);
  }

  const onRemoveFuncionSubFuncion = (idFuncion,idSubFuncion) =>{
    let remove = idFuncion.toString() + idSubFuncion.toString();
    setFuncionesSubFunciones([...funcionesSubFunciones.filter((f)=>(f.idFuncion.toString()+f.idSubFuncion.toString())!==remove)])}

  const comprobarErrores = () => {
    return (isInvalidArea || isInvalidDN|| isInvalidCodArea)
  }

  const isInvalidDN = useMemo(() => {return dn===undefined},[dn])
  const isInvalidArea = useMemo(() => {return area===undefined || area.trim()===""},[area])
  const isInvalidCodArea = useMemo(() => {return codArea===undefined || codArea.trim()===""},[codArea])
  // const isInvalidResponsable = useMemo(() => {return responsable===undefined},[responsable])

  
  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="Área" isInvalid={isInvalidArea}>
            <EuiFieldText fullWidth value={area} name="txtArea" onChange={e => setArea(e.target.value)} isInvalid={isInvalidArea}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
          <EuiFormRow label="Código" isInvalid={isInvalidCodArea}>
            <EuiFieldText maxLength={3} value={codArea} name="txtCodArea" onChange={e => setCodArea(e.target.value.toUpperCase())} isInvalid={isInvalidCodArea}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Dirección Negocio" isInvalid={isInvalidDN}>
          <ComboDNs fullWidth selectedOptions={dn} onChange={value => setDn(value)} isInvalid={isInvalidDN}/>
        </EuiFormRow>
      </EuiFlexItem>
      {/* <EuiFlexItem>
        <EuiFormRow fullWidth label="Responsable" isInvalid={isInvalidResponsable}>
          <ComboresponsablesArea fullWidth selectedOptions={responsable} onChange={value => setResponsable(value)} isInvalid={isInvalidResponsable}/>
        </EuiFormRow>
      </EuiFlexItem> */}
    </EuiFlexGroup>
    <EuiSpacer size="s" />
    <SelectorFuncionSubFuncion onAgregateFuncionSubfuncion={onAgregateFuncionSubfuncion} funcionesSubFunciones={funcionesSubFunciones} onRemoveFuncionSubFuncion={onRemoveFuncionSubFuncion}/>
    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;